// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6a23dc30","182":"cc8ec432","359":"5bcc9b05","643":"5a5d7fa2","928":"3efe486b"}[chunkId] + ".chunk.js";
};